module.exports = __webpack_public_path__ + "img/16.48870ad0.jpg";